import axios from 'axios';
import { Message, Notification } from 'element-ui';
import router from '../router/index.js'
import { API_BASE_URL } from "@/config/index.js";

const http = axios.create({
    baseURL: API_BASE_URL,
    timeout: 100000,
});

// 请求拦截器
http.interceptors.request.use((config) => {
    let config1 = config
    config1.headers = {
        'Content-Type': "application/json",
    }

    // ==============================================
    // 🔥 总后台独立 KEY：admin_main_token / admin_main_shopId
    // ==============================================
    let token = sessionStorage.getItem('admin_main_token') || ''
    let shop_id = sessionStorage.getItem('admin_main_shopId') || ''

    if (config1.data) {
        config1.data.token = token
        config1.data.shop_id = shop_id
    } else {
        config1.data = { token, shop_id }
    }

    if (config.url.indexOf('userWithdrawExcelExport') > -1 || config.url.indexOf('shopWithdrawExcelExport') > -1) {
        config1.responseType = 'blob'
        config1.fileName = '导出文件'
    }

    return config1;

}, function (error) {
    return Promise.reject(error);
});

// 响应拦截器
http.interceptors.response.use((response) => {
    if (response.request.responseURL.indexOf('userWithdrawExcelExport') > -1 || response.request.responseURL.indexOf('shopWithdrawExcelExport') > -1) {
        if (response.data) {
            let blob = new Blob([response.data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;"
            });
            let url = window.URL.createObjectURL(blob);
            let a = document.createElement("a");
            a.href = url;
            a.download = response.config.fileName || '导出文件';
            a.click();
        }
        return '成功'
    }

    if (response.data) {
        if (response.data.status == 1) {
            return response.data;
        } else if (response.data.status == -998 || response.data.status == -999) {
            Notification.error({
                title: '登录过期',
                message: '请重新登录'
            });

            // ==============================================
            // 🔥 登录过期 → 清空总后台自己的缓存
            // ==============================================
            sessionStorage.removeItem('admin_main_token')
            sessionStorage.removeItem('admin_main_shopId')

            router.replace('/')
        } else {
            Message.error({
                title: '错误',
                type: 'warning',
                message: response.data.info || '操作失败'
            });
            return ''
        }
    }
}, function (error) {
    Message.error({
        showClose: true,
        message: '请求失败'
    })
    return Promise.reject(error);
});

export default http